import { CONSTRUCTOR } from '..';
import * as Fragments from './fragments';

// LeadField GraphQL Mutations.

// UPDATE update lead field GraphQL schema.
export const UPDATE = (props = {}) => {
  const defaultProps = {
    type: 'mutation',
    name: 'updateLeadFieldSettings',
    args: [
      { name: 'content', type: 'String', required: true },
    ],
    argsMap: [
      { name: 'content', value: 'content' },
    ],
    fields: '{...LeadFieldSettingsResponseFields}',
    fragments: [Fragments.leadFieldSettingsResponse],
  };
  let options = defaultProps;
  if (props) {
    options = Object.assign(defaultProps, props);
  }
  return CONSTRUCTOR.GRAPHQL(options);
};
